/* MedEazy guides: live price box, 'On this page' list and treatment buttons.
   Uses the shared price engine (assets/mz.js), so prices come from the pricing files in MedEazy settings. */
(function () {
  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  function lowAny(t) { var b = null; (t.columns || []).forEach(function (c, i) { var s = MZ.stats(t, i); if (s.min != null && (b == null || s.min < b)) b = s.min; }); return b; }

  function matchTreatments(el) {
    var text = ' ' + (el.getAttribute('data-text') || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ') + ' ';
    var max = +(el.getAttribute('data-max') || 2);
    var cands = [];
    MZ.order.forEach(function (k) {
      var t = MZ.T[k];
      [t.fullname, t.name, k.replace(/-/g, ' '), t.ingr].concat(String(t.aliases || '').split(',')).forEach(function (w) {
        w = String(w || '').toLowerCase().replace(/[^a-z0-9.]+/g, ' ').trim();
        if (w.length > 3) cands.push({ k: k, w: w });
      });
    });
    cands.sort(function (a, b) { return b.w.length - a.w.length; });
    var found = {};
    cands.forEach(function (c) {
      var i = text.indexOf(' ' + c.w + ' ');
      if (i > -1) { if (found[c.k] == null || i < found[c.k]) found[c.k] = i; text = text.split(' ' + c.w + ' ').join('  '); }
    });
    var keys = Object.keys(found).sort(function (a, b) { return found[a] - found[b]; });
    if (!keys.length) keys = (el.getAttribute('data-fallback') || '').split(',').map(function (x) { return x.trim(); }).filter(function (k) { return MZ.T[k]; });
    return keys.slice(0, max);
  }

  function initPricebox(el) {
    var keys = matchTreatments(el);
    var label = el.getAttribute('data-label') || '';
    if (!keys.length) { el.hidden = true; return; }
    el.innerHTML = '<p class="mz-eyebrow">' + esc(label) + '</p>' + keys.map(function (k) {
      var t = MZ.T[k];
      var head = '<div class="mz-pricebox__head"><b>' + esc(t.fullname || t.name) + '</b><span>' + (t.soon ? 'Prices soon' : 'from <strong class="mz-num">' + MZ.gbp(lowAny(t)) + '</strong>') + '</span></div>';
      var rows = t.soon ? '<p class="mz-pricebox__note">We\'re collecting verified prices from GPhC-registered pharmacies.</p>' :
        '<ul>' + t.columns.map(function (c, i) {
          var st = MZ.stats(t, i); if (st.min == null) return '';
          return '<li><span class="d">' + esc(c.label) + '</span><span class="p mz-num">' + MZ.gbp(st.min) + '</span><span class="n">' + esc(st.list[0].r.name) + '</span></li>';
        }).join('') + '</ul>';
      var link = t.page ? '<a class="mz-pricebox__link" href="' + esc(t.page) + '">' + (t.soon ? 'See ' + esc(t.name) : 'Compare all ' + (t.rows || []).length + ' pharmacies') + ' →</a>' : '';
      return '<div class="mz-pricebox__t">' + head + rows + link + '</div>';
    }).join('') + '<p class="mz-pricebox__foot">Lowest listed price ' + esc(MZ.T[keys[0]].unit || '') + ', checked daily.</p>';
  }

  function initCtas(el) {
    var keys = matchTreatments(el).filter(function (k) { return MZ.T[k].page; });
    if (!keys.length) return;
    el.innerHTML = keys.map(function (k, i) {
      var t = MZ.T[k];
      return '<a class="mz-btn ' + (i ? 'mz-btn--ghost' : 'mz-btn--solid') + '" href="' + esc(t.page) + '">Compare ' + esc(t.fullname || t.name) + ' prices</a>';
    }).join('');
  }

  function initToc(el) {
    var body = $('[data-mz-article-body]'); if (!body) return;
    var hs = $$('h2', body).filter(function (h) { return h.textContent.trim().length > 2; });
    if (hs.length < 3) return;
    var used = {};
    $('ol', el).innerHTML = hs.map(function (h) {
      if (!h.id) { var id = h.textContent.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section'; while (used[id]) id += '-2'; used[id] = 1; h.id = id; }
      return '<li><a href="#' + esc(h.id) + '">' + esc(h.textContent.trim()) + '</a></li>';
    }).join('');
    el.hidden = false;
  }

  function run(root) {
    root = root || document;
    $$('[data-mz-toc]', root).forEach(initToc);
    var go = function () {
      $$('[data-mz-pricebox]', root).forEach(initPricebox);
      $$('[data-mz-article-ctas]', root).forEach(initCtas);
    };
    var wait = function (n) {
      if (window.MZ && MZ.ready && MZ.ready.then) { MZ.ready.then(go); return; }
      if (n > 100) return; setTimeout(function () { wait(n + 1); }, 50);
    };
    wait(0);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
